
/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

/*
<!-- <mat-option value='2'>Home Globe - Section 1 (2)</mat-option>
<mat-option value='3'>Home Globe - Section 2 (3)</mat-option> -->
<mat-option value='4'>Summary Dashboard - Key KPIs Circles (4)</mat-option>
<mat-option value='5'>Summary Dashboard - UTr Table (5)</mat-option>
<mat-option value='34'>SDG Contribution Dashboard (34)</mat-option>
<mat-option value='40'>Impact Dashboard - Score as Proportion (40)</mat-option>
 */
export const HOME_GLOBE = '3';
export const SUMMARY_DASHBOARD_CIRCLES = '4';
export const SUMMARY_DASHBOARD_UTR_TABLE = '5';
export const UNIVERSAL_TRACKERS_DASHBOARD = '35';
export const IMPACT_DASHBOARD_SCORE_PROPORTION = '40';
